import script from "./AssessmentUtilities.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentUtilities.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentUtilities.vue?vue&type=style&index=0&id=a3f82340&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3f82340"]])

export default __exports__